const state = () => ({
  isLoading: false,
  is_active_redirect_for_406: false,
  is_active_redirect_for_418: false,
});

// getters
const getters = {};

// actions
const actions = {
  loadingOn({ commit }) {
    commit('loadingToggleOn');
  },
  loadingOff({ commit }) {
    commit('loadingToggleOff');
  },
  initializeStore({ commit }) {
    const regex406 = /(carrier_vpn_block|user_country_block)$/;
    const regex418 = /(pending-access-review)$/;

    if (!regex406.test(window.location.pathname)) {
      commit('setIsActiveRedirectFor406', false);
    } else if (!regex418.test(window.location.pathname)) {
      commit('setIsActiveRedirectFor418', false);
    }
  },
};

// mutations
const mutations = {
  loadingToggleOn(state) {
    state.isLoading = true;
  },
  loadingToggleOff(state) {
    state.isLoading = false;
  },
  setIsActiveRedirectFor406(state, bool) {
    state.is_active_redirect_for_406 = bool;
  },
  setIsActiveRedirectFor418(state, bool) {
    state.is_active_redirect_for_418 = bool;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
